import { render, staticRenderFns } from "./sale-item.vue?vue&type=template&id=117fd6af&scoped=true&"
import script from "./sale-item.vue?vue&type=script&lang=js&"
export * from "./sale-item.vue?vue&type=script&lang=js&"
import style0 from "./sale-item.vue?vue&type=style&index=0&id=117fd6af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117fd6af",
  null
  
)

export default component.exports